import { OverlayWappPanel, WappPanel } from '$logic/wapp-panels'

const POLL_CREATOR_WAPP_ID = 'poll-poll-creator'
const BLOG_CREATOR_WAPP_ID = 'blog-blog-creator'
const POST_CREATOR_WAPP_ID = 'post-post-creator'
const FORUM_CREATOR_WAPP_ID = 'forum-forum-creator'
const RAHKAR_CREATOR_WAPP_ID = 'rahkar-rahkar-creator'
const NEVISEH_CREATOR_WAPP_ID = 'neviseh-neviseh-creator'

const EVENT_CREATOR_WAPP_ID = 'event-event-creator'
const MULTIMEDIA_CREATOR_WAPP_ID = 'multimedia-multimedia-creator'
const FORM_CREATOR_WAPP_ID = 'form-form-creator'
const MAP_WAPP_ID = 'map-map'
const SUPPORT_WAPP_ID = 'support-support'
const GENERAL_EXAM_WAPP_ID = 'general-exam-general-exam-creator'
const GENERATIVE_ID_WAPP_ID = 'generative-ai-auto-reals'

const ISSUE_WAPP_ID = 'porsesh-porsesh-main'

export function openIssue(channelId: string) {
  WappPanel.openWapp({ wappId: ISSUE_WAPP_ID, input: { channelId } })
}

export function openPollCreator() {
  WappPanel.openWapp({ wappId: POLL_CREATOR_WAPP_ID })
}

export function openNeviseCreator() {
  WappPanel.openWapp({ wappId: NEVISEH_CREATOR_WAPP_ID })
}

export function openBlogCreator() {
  WappPanel.openWapp({ wappId: BLOG_CREATOR_WAPP_ID })
}

export function openPostCreator() {
  WappPanel.openWapp({ wappId: POST_CREATOR_WAPP_ID })
}

export function openGeneralExamCreator() {
  WappPanel.openWapp({ wappId: GENERAL_EXAM_WAPP_ID })
}
export function openGenerativeAI() {
  WappPanel.openWapp({ wappId: GENERATIVE_ID_WAPP_ID })
}

export function openForumCreator() {
  WappPanel.openWapp({ wappId: FORUM_CREATOR_WAPP_ID })
}

export function openRahkarCreator() {
  WappPanel.openWapp({ wappId: RAHKAR_CREATOR_WAPP_ID })
}

export function openNevisehCreator() {
  WappPanel.openWapp({ wappId: NEVISEH_CREATOR_WAPP_ID })
}

export function openEventCreator() {
  WappPanel.openWapp({ wappId: EVENT_CREATOR_WAPP_ID })
}
export function openFormCreator() {
  WappPanel.openWapp({ wappId: FORM_CREATOR_WAPP_ID })
}

export function openMultimediaCreator(type?: MultimediaType) {
  WappPanel.openWapp({
    wappId: MULTIMEDIA_CREATOR_WAPP_ID,
    ...(type && { input: { type } }),
  })
}
export function openMap() {
  OverlayWappPanel.openWapp({
    wappId: MAP_WAPP_ID,
  })
}
export function openSupportWapp() {
  WappPanel.openWapp({
    wappId: SUPPORT_WAPP_ID,
  })
}

export const MULTIMEDIA_TYPES = {
  'ویدیو کلیپ': 'videoClip',
  'فیلم و مستند': 'movie',
  'صوت و موسیقی': 'music',
  پادکست: 'podcast',
  'طرح گرافیکی': 'picture',
  کتاب: 'book',
  'نرم افزار': 'application',
  غیره: 'file',
} as const

export type MultimediaLabelType = keyof typeof MULTIMEDIA_TYPES
export type MultimediaType = (typeof MULTIMEDIA_TYPES)[MultimediaLabelType]
